import React from 'react'
import PropTypes from 'prop-types'
import { Card, Input } from 'antd'
import styled from 'styled-components'

const { TextArea } = Input

const StyledCard = styled(Card)`
	margin-bottom: 1.5rem;

	@media (max-width: 768px) {
		margin-bottom: 1rem;
	}
`

const Message = ({ message, onMessageChange }) => {
	return (
		<StyledCard title="Mensagem para os Signatários">
			<TextArea
				value={message || ''}
				onChange={onMessageChange}
				placeholder="Digite a mensagem que será enviada aos signatários"
				rows={4}
			/>
		</StyledCard>
	)
}

Message.propTypes = {
	message: PropTypes.string,
	onMessageChange: PropTypes.func.isRequired,
}

export default Message
